import React from "react";

import { Row, Col } from "antd";

import { EditServiceContextProvider, useRateCardContext } from "components/ratecard/contextProviders";
import PickAndPackRates from "components/ratecard/PickAndPackRates";
import SuppliesRates from "components/ratecard/SuppliesRates";
import WarehouseRates from "components/ratecard/WarehouseRates";

import { NsSettings } from "../../../../../components/ratecard/NsSettings/NsSettings";

/**
 * TODO: orest - maybe move to separate components?
 * Renders corresponding from based on slug
 */
const getServiceForm = () => {
  const componentsMap: Record<string, React.ReactNode> = {
    nsSettings: (
      <EditServiceContextProvider key="nsSettings">
        <NsSettings />
      </EditServiceContextProvider>
    ),
    warehousing: (
      <EditServiceContextProvider key="warehouse">
        <WarehouseRates />
      </EditServiceContextProvider>
    ),
    pickPack: (
      <EditServiceContextProvider key="pickAndPack">
        <PickAndPackRates />
      </EditServiceContextProvider>
    ),
    supplies: (
      <EditServiceContextProvider key="supplies">
        <SuppliesRates />
      </EditServiceContextProvider>
    ),
  };

  return componentsMap;
};

const ServicePage: React.FC = () => {
  const { currentService } = useRateCardContext();

  return (
    <Row justify="center">
      <Col span={24}>{currentService ? getServiceForm()[currentService.slug] : getServiceForm()["nsSettings"]}</Col>
    </Row>
  );
};

export default ServicePage;
